import StbButton from "@storeblocks/button";
import { PaddedSurface } from "App/global-style";
import styled from "styled-components";

export const Button = styled(StbButton)`
  margin-left: ${({ theme }) => `-${theme.spacing.md}`};
  text-decoration: underline;

  & + * {
    margin-top: ${({ theme }) => theme.spacing.lg};
  }
`;

export const TransparentSurface = styled(PaddedSurface)`
  background-color: transparent;
  margin-top: ${({ theme }) => theme.spacing.md};
`;

export const VehicleContainer = styled(PaddedSurface)`
  align-items: center;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  & + & {
    margin-top: 12px;
  }

  @media screen and (max-width: 482px) {
    align-items: flex-start;
    flex-direction: column;

    & > *:last-child {
      margin-top: ${({ theme }) => theme.spacing.xs};
    }
  }
`;

export const BoldText = styled.span`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;
